import { DayPreset } from '../../../../../../types/types';

export const isNamedDayPresetValue = (value: string): boolean =>
  [
    DayPreset.CURRENT_DAY as string,
    DayPreset.PREVIOUS_DAY as string,
    DayPreset.TODAY as string,
  ].includes(value);
